"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 * Add loyalty snapshot to order after payment
 * @param event event of type AddOrderLoyaltySnapshotEvent
 * @param prevState previous order state
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const orderLevelRewards = ((order === null || order === void 0 ? void 0 : order.adjustments) || []).filter(adj => adj.adjustmentType === domain_1.AdjustmentType.REWARD);
    const itemLevelRewards = ((order === null || order === void 0 ? void 0 : order.orderItems) || [])
        .map(orderItem => {
        return (orderItem.adjustments || []).filter(adj => adj.adjustmentType === domain_1.AdjustmentType.REWARD);
    })
        .flat();
    const rewardsRedeemed = orderLevelRewards.concat(itemLevelRewards);
    const loyaltySnapshot = {
        ...event.loyaltySnapshot,
        organization: order.organization,
        customer: order.customer,
        createdAt: event.timestamp,
        rewardsRedeemed,
    };
    return {
        ...order,
        loyaltySnapshot,
    };
}
exports.default = default_1;
//# sourceMappingURL=addOrderLoyaltySnapshot.js.map